import script from "./TopNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavbar.vue?vue&type=script&setup=true&lang=js"

import "./TopNavbar.vue?vue&type=style&index=0&id=21a94eac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a94eac"]])

export default __exports__